import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import { setEditId, selectUserById, setBanId } from "src/store/community/usersSlice";
import { destroyUser, fetchUser } from "src/actions/community/usersActions";
import { formattedDate } from "src/helpers/DateHelpers";
import communityUrls from "src/configs/community/communityUrls";

import { Badge, message } from "antd";
import PageLayout from "../_partials/PageLayout";
import SummaryShow from "src/componets/SummaryShow";
import Details from "./_partials/_Details";
import Tabs from "src/componets/Tabs";
import Edit from "./Edit";
import Block from "./Block";
import { Button, ButtonDestroy, ButtonEdit } from "src/componets/Buttons";
import Comments from "./_partials/_Comments";
import SentComments from "./_partials/_SentComments";
import Title from "./_partials/_Title";
import EditComment from "src/pages/community/Comments/Edit";
import SidebarShow from "src/pages/community/Users/_partials/_SidebarShow";
import StatsIcons from "src/componets/StatsIcons";
import IconText from "src/componets/IconText";
import {
  AppstoreAddOutlined,
  HeartOutlined,
  LikeOutlined,
  MessageOutlined, StopOutlined,
  UserOutlined,
  UserSwitchOutlined
} from "@ant-design/icons";

const Show: React.FC = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const user = useAppSelector(state => id ? selectUserById(state, id) : undefined);

  useEffect(() => {
    if (id) {
      dispatch(fetchUser(id));
    }
  }, [id, dispatch]);

  function onClickBan() {
    if (user) {
      dispatch(setBanId(user.id));
    }
  }

  function onClickEdit() {
    if (user) {
      dispatch(setEditId(user.id));
    }
  }

  function onClickDestroy() {
    if (user) {
      handleDestroy(user.id).catch(console.error);
    }
  }

  async function handleDestroy (id: any) {
    const resultAction = await dispatch(destroyUser(id));

    if (destroyUser.fulfilled.match(resultAction)) {
      message.success(`ItemID ${id} was successful deleted`);
      setTimeout(() => navigate(communityUrls.usersPath()), 1000);
    }

    if (destroyUser.rejected.match(resultAction)) {
      message.error(resultAction.error.message);
    }
  }

  const renderTitle = () => (
    <Badge dot color={user?.is_online ? 'green' : 'red'} offset={[5, 0]}>
      {user && <Title name={user.name} bannedUntil={user.banned_until} mutedUntil={user.muted_until} />}
    </Badge>
  )

  return (
    <PageLayout className='v-users-show'>
      <div className='v-container-fluid'>
        <div className='o-header'>
          {
            user &&
              <SummaryShow
                title={renderTitle()}
                subtitle={`Last seen: ${formattedDate(user.launch_at).fromNow}`}
                image={user.avatar_url}
                createdAt={user.created_at}
                updatedAt={user.updated_at}
                actions={[
                  <Button key='button-ban' onClick={onClickBan} title='Block' icon={StopOutlined} />,
                  <ButtonEdit key='button-edit' onClick={onClickEdit} />,
                  <ButtonDestroy key='button-destroy' onClick={onClickDestroy} />
                ]}
                className='v-mb-15'
              />
          }

          <StatsIcons
            icons={[
              <IconText tooltip='popular' icon={HeartOutlined} text={user?.popular_count} />,
              <IconText tooltip='likes' icon={LikeOutlined} text={user?.likes_count} />,

              <IconText tooltip='posts' icon={AppstoreAddOutlined} text={user?.posts_count} />,
              <IconText tooltip='comments' icon={MessageOutlined} text={user?.comments_count} />,

              <IconText tooltip='following' icon={UserOutlined} text={user?.following_count} />,
              <IconText tooltip='followers' icon={UserSwitchOutlined} text={user?.followers_count} />
            ]}
          />

          <Tabs
            paramsKey='tab'
            destroyInactiveTabPane={true}
            items={[
              { label: 'Details', key: 'posts', children: <Details user={user} /> },
              { label: 'Comments', key: 'comments', children: <Comments userId={user?.id} /> },
              { label: 'Comments Created', key: 'sent_comments', children: <SentComments userId={user?.id} /> },
            ]}
          />
        </div>
      </div>

      <Edit />
      <Block />

      <SidebarShow user={user} />

      <EditComment />
    </PageLayout>
  )
}

export default Show;
